import React from 'react';
import PropTypes from 'prop-types';
import 'react-dates/initialize';
import { DateRangePicker,CalenderDay } from 'react-dates';
import { START_DATE, END_DATE, ANCHOR_LEFT, ANCHOR_RIGHT, HORIZONTAL_ORIENTATION, VERTICAL_ORIENTATION, OPEN_UP, OPEN_DOWN } from 'react-dates/constants';
import { DATES_MOMENT_FORMAT, DIV_ID, DATES_DISPLAY_FORMAT } from '../common/constants';
import classnames from 'classnames';
import moment from 'moment';
// import { CalenderDay } from './CalenderDay';
import { mapLocale } from '../common/utils';
import css from './styles.less';
import 'react-dates/lib/css/_datepicker.css';


class DateRange extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            //disabled: false,
            isAnyCheckoutAvailabilityExist: false,
        };

        this.lastUnavailabilityCheckout = null;
    }

    componentWillReceiveProps(nextProps) {
        const isAnyCheckoutAvailabilityExist = nextProps.checkoutAvailability && Object.keys(nextProps.checkoutAvailability).length > 0;
        const { checkinAvailability, checkoutAvailability, checkinDate } = this.props;

        let isNewCheckinAvailability = false;
        if (!Object.is(checkinAvailability, nextProps.checkinAvailability)) {
            isNewCheckinAvailability = true;
        }
        let isNewCheckoutAvailability = false;
        if (!Object.is(checkoutAvailability, nextProps.checkoutAvailability)) {
            isNewCheckoutAvailability = true;
        }
        this.setState(
            {
                toDate: nextProps.toDate,
                fromDate: nextProps.fromDate,
                checkinDate: nextProps.checkinDate,
                checkoutDate: nextProps.checkoutDate,
                //disabled: nextProps.availabilityLoading,
                isAnyCheckoutAvailabilityExist: isAnyCheckoutAvailabilityExist,
                isNewCheckinAvailability: isNewCheckinAvailability,
                isNewCheckoutAvailability: isNewCheckoutAvailability,

            }
        );
    }

    onDatesChange = ({ startDate, endDate }) => {

        const { onChangeCheckoutDate, onChangeCheckinDate, displayDateFormat, focusedInput } = this.props;

        if (focusedInput == START_DATE) {
            // return dates as strings according to the format provided via props
            const startDateStr = startDate.format(displayDateFormat);
            this.lastUnavailabilityCheckout = null;
            onChangeCheckinDate(startDateStr);

        }
        else if (focusedInput == END_DATE) {
            // return dates as strings according to the format provided via props
            const endDateStr = endDate.format(displayDateFormat);
            onChangeCheckoutDate(endDateStr);
        }

    }

    outSideRange = (val) => {

        const { fromDate, toDate } = this.state;
        const { focusedInput } = this.props;
        const today = moment();
        const isInThePast = val.isBefore(today, "day");
        const fromDateObj = moment(this.state.checkinDate, DATES_DISPLAY_FORMAT);
        if (focusedInput == START_DATE) {
            return isInThePast;
        } else if (focusedInput == END_DATE) {
            return isInThePast || val.isSameOrBefore(fromDateObj, "day");
        }
    }

    //if focusedInput is for checkout , dont do noting (no need for availability fetching)
    onNextMonthClick = (currentDisplayDate) => {
        if (this.props.focusedInput == END_DATE) return;
        this.props.onNextMonthClick(currentDisplayDate);
    }
    onPrevMonthClick = (currentDisplayDate) => {
        if (this.props.focusedInput == END_DATE) return;
        this.props.onPrevMonthClick(currentDisplayDate);
    }

    isCheckinDayBlocked = (val) => {
        const { checkinAvailability, focusedInput, openAllDates, offlineAvailability } = this.props;

        // Open all dates!
        if (openAllDates) return false;

        // Blocking previous days to the current day or checkin date ( depends whether checkin date had selected or not )
        // if (val.isBefore(moment(),"day") || val.isBefore(moment(checkinDate,this.props.displayDateFormat),"day")) return true;
        if (val.isBefore(moment(), "day")) return true;
        console.log(`${val.format(DATES_MOMENT_FORMAT)} is ${checkinAvailability[val.format(DATES_MOMENT_FORMAT)].available} or ${checkinAvailability[val.format(DATES_MOMENT_FORMAT)].closedForArrival}`);

        if (offlineAvailability) return false;

        // Selecting checkin date....
        const isCheckinDateBlocked = () => {

            if (focusedInput != START_DATE) return false;

            const day = checkinAvailability[val.format(DATES_MOMENT_FORMAT)];

            const isCheckinAvialabilityExist = !(typeof (day) == 'undefined');

            if (!isCheckinAvialabilityExist) return false;

            return !day.available || day.closedForArrival;
        }

        return isCheckinDateBlocked();
    }

    isCheckoutDayBlocked = (val) => {
        const { checkoutAvailability, focusedInput, openAllDates, checkinDate, offlineAvailability } = this.props;
        const { isAnyCheckoutAvailabilityExist } = this.state;

        if (offlineAvailability) return false;

        const day = checkoutAvailability[val.format(DATES_MOMENT_FORMAT)];

        const isCheckoutAvialabilityExist = !(typeof (day) == 'undefined');

        if (!isCheckoutAvialabilityExist) return false;

        // Open all dates!
        if (openAllDates) return false;
        if (day) {
            const closedForDeparture = day.closedForDeparture;
            const available = day.available;
            return closedForDeparture || !available;
        } else {
            return true;
        }
    }

    isDateAfterLastUnavailabilityCheckout = (val, data) => {
        if (this.lastUnavailabilityCheckout && val.isAfter(moment(this.lastUnavailabilityCheckout, data.displayDateFormat), "day"))
            return true;
        return false;
    }

    isDatePrecedingTodayAndCheckin = (val, data) => {
        //blocking previous days to the current day or checkin date ( depends whether checkin date had selected or not )
        if (val.isBefore(moment(), "day"))
            return true;
        if (data.checkinDate && val.isSameOrBefore(moment(data.checkinDate, data.displayDateFormat), "day"))
            return true;

        return false;
    }

    isAvailabilityExists = (val, data) => {
        if (data.focusedInput != END_DATE || !data.isAnyCheckoutAvailabilityExist)
            return false;
        const isCheckoutAvialabilityExist = !(typeof (data.checkoutAvailability[val.format(DATES_MOMENT_FORMAT)]) == 'undefined');
        if (!isCheckoutAvialabilityExist)
            return false
        return true;
    }

    isDateAvailableForCheckout = (val, data) => {
        const inMinLosRange = (val) => {
            const checkinDateMoment = moment(data.checkinDate, data.displayDateFormat);
            let minNightsForCheckinDate = data.checkinAvailability[data.checkinDateMoment.format(DATES_MOMENT_FORMAT)];
            minNightsForCheckinDate = minNightsForCheckinDate.minLOS;
            const firstPossibleCheckoutDate = data.checkinDateMoment.add(minNightsForCheckinDate, 'day');
            const inMinLosRange = val.isSameOrAfter(firstPossibleCheckoutDate, 'day');
            return inMinLosRange;
        }

        const day = data.checkoutAvailability[val.format(DATES_MOMENT_FORMAT)];

        let isBlocked = false;
        //if day is closed for departure, block only this day for checkout.
        if (day.closedForDeparture)
            isBlocked = true;
        //check if current day in min los range of checkin date, if dont, block the day, if do, continue checking.
        if (!inMinLosRange(val))
            isBlocked = true;

        if (day.available)
            return isBlocked;

        //if day is unavailable, save this day and block all forwarded days for checkout.
        this.lastUnavailabilityCheckout = val;
        return isBlocked;
    }

    initialVisibleMonth = () => {
        return this.state.checkinDate ? moment(this.state.checkinDate, this.props.displayDateFormat) : moment();
    }

    renderDayContents = val => {
        const {checkinDate, displayDateFormat, checkinAvailability} = this.state;
        const {focusedInput} = this.props;
        let dayProps = {
            isCheckout: false,
        }
        if(focusedInput == END_DATE){
            dayProps.isCheckout = true;
            const checkinDateMoment = moment(checkinDate, displayDateFormat);
            let minNightsForCheckinDate = checkinAvailability[checkinDateMoment.format(DATES_MOMENT_FORMAT)];
            minNightsForCheckinDate = minNightsForCheckinDate.minLOS;
            dayProps.checkinMinLos = minNightsForCheckinDate;
            dayProps.firstDayAfterMinLos = checkinDateMoment.add(minNightsForCheckinDate, 'day');
        }
        
        return (
            <CalenderDay {...dayProps}/>
        )
    };

    renderDayContentss = dayProps => ( <CalenderDay {...dayProps}/> )

    renderMobileCalendarTitle = () =>{
        const  {focusedInput, titles} = this.props;
        let resultTitle = titles.SelectCheckinDate;
        if(focusedInput == END_DATE){
            resultTitle = titles.SelectCheckoutDate;
        }
        const toRender = (
            <div className="mobile-daterange-calendar-title">{resultTitle}</div>
        )
        return toRender;
    }

    render() {
        const {
            lang,
            validity,
            notValid,
            direction,
            isRounded,
            titles,
            checkinDate,
            checkoutDate,
            displayDateFormat,
            onNextMonthClick,
            onPrevMonthClick,
            availabilityLoading,
            onFocusChange,
            focusedInput,
            calendarOpenDirection,
            isMobileView
        } = this.props;

        const { disabled, isNewCheckinAvailability, isNewCheckoutAvailability } = this.state;
        const openDirection = calendarOpenDirection === 'up' ? OPEN_UP : OPEN_DOWN;
        const isCheckinDateError = validity.checkinDate && validity.checkinDate.error;
        const isCheckoutDateError = validity.checkoutDate && validity.checkoutDate.error;

        const searchboxElm = document.getElementById('silverSearchBox');
        const wrapperElm = document.getElementById(DIV_ID);
        const widthLimit = 618;
        let numbOfMon = 2; //(isWrapperOrSearchboxDivExists && wrapperElm.offsetWidth < 618) ? 1 : 2;

        if (wrapperElm && wrapperElm.offsetWidth < widthLimit ||
            searchboxElm && searchboxElm.offsetWidth < widthLimit) {
            numbOfMon = 1
        }

        moment.locale(mapLocale(lang));
        let focusedInputByError = isCheckinDateError ? START_DATE : isCheckoutDateError ? END_DATE : focusedInput;
        const shouldRTL = direction && direction.toLowerCase() === 'right'

        const startDateMoment = checkinDate && moment(checkinDate, displayDateFormat);
        const endtDateMoment = checkoutDate && moment(checkoutDate, displayDateFormat);


        // Netanel 19/03/18 - workaround to be able refresh calender day classes (blocked etc..)
        // this is because react-dates rerender calender days if the isDayBlocked ref is changed.
        const isDayBlocked =
            focusedInput == START_DATE ?
                isNewCheckinAvailability ? (day) => this.isCheckinDayBlocked(day) : this.isCheckinDayBlocked
                : isNewCheckoutAvailability ? (day) => this.isCheckoutDayBlocked(day) : this.isCheckoutDayBlocked;

								// Netanel 15/8/18 - set larger day boxes so the whole calendar will cover full width of the screen.
					   // Calculate box size for each day of the week (7)
        let custDaySize = 39;         
        if(isMobileView){
            numbOfMon =1;
            custDaySize = Math.round((window.innerWidth-35)/7)
        }

        return (
            <div className={
                classnames(
                    css.datePicker,
                    css[direction],
                    isRounded && css.roundBorders,
                    notValid && css.notValid
                )}
                ref={(div) => { this.DatePickerHolder = div; }}
            >

                <DateRangePicker
                    focusedInput={focusedInputByError}
                    startDate={startDateMoment}
                    endDate={endtDateMoment}
                    onDatesChange={this.onDatesChange}
                    onFocusChange={onFocusChange}
                    numberOfMonths={numbOfMon}
                    isDayBlocked={isDayBlocked}
                    enableOutsideDays={false}
                    onNextMonthClick={this.onNextMonthClick}
                    onPrevMonthClick={this.onPrevMonthClick}
                    anchorDirection={!shouldRTL ? ANCHOR_LEFT : ANCHOR_RIGHT}
                    ref={ref => { this.dateRangePicker = ref; }}
                    isOutsideRange={this.outSideRange}
                    initialVisibleMonth={this.initialVisibleMonth}
                    startDatePlaceholderText={titles.CheckinDate}
                    endDatePlaceholderText={titles.CheckoutDate}
                    startDateId='checkin'
                    endDateId='checkout'
                    displayFormat={displayDateFormat}
                    disabled={disabled}
                    isRTL={shouldRTL}
                    hideKeyboardShortcutsPanel
                    openDirection={openDirection}
                    readOnly={true}
                    daySize={custDaySize}
                    // calendarInfoPosition={isMobileView ? "top" : null} 
                    // renderCalendarInfo={this.renderMobileCalendarTitle}
                    // renderCalendarDay={this.renderDayContentss}
                />
            </div>
        );
    }
};

DateRange.propTypes = {
    calendarOpenDirection: PropTypes.string,
    focusedInput: PropTypes.any,
    format: PropTypes.string,
    isRounded: PropTypes.bool,
    direction: PropTypes.oneOf(['left', 'right']),
    checkinDate: PropTypes.any,
    checkoutDate: PropTypes.any,
    openAllDates: PropTypes.bool,
    checkinAvailability: PropTypes.object,
    checkoutAvailability: PropTypes.object,
    availabilityLoading: PropTypes.bool,
    onChangeCheckinDate: PropTypes.func,
    onChangeCheckoutDate: PropTypes.func,
    onNextMonthClick: PropTypes.func,
    onPrevMonthClick: PropTypes.func,
    onClickOpenCalendar: PropTypes.func,
    lang: PropTypes.string,
    titles: PropTypes.object,
    validity: PropTypes.object,
};

DateRange.defaultProps = {
    focusedInput: null,
    format: '',
    isRounded: false,
    direction: 'left',
    dates: {},
    onChangeCheckinDate() { },
    onChangeCheckoutDate() { },
    onNextMonthClick() { },
    onPrevMonthClick() { },
    onClickOpenCalendar() { },
    lang: 'eng',
    validity: {},
};

export default DateRange;



// WEBPACK FOOTER //
// ./src/components/DateRange/DateRange.js